var map = {
	"./about-bg-new.webp": 985,
	"./about-bg.webp": 3602,
	"./banner.webp": 7267,
	"./banners/banner_1.webp": 7619,
	"./banners/banner_2.webp": 9970,
	"./bg-vector.webp": 5846,
	"./catalog.webp": 2708,
	"./catalogs/catalog_1.webp": 1529,
	"./catalogs/catalog_2.webp": 1852,
	"./catalogs/catalog_3.webp": 95,
	"./contacts/1-default.svg": 5809,
	"./contacts/1-white.svg": 2745,
	"./contacts/2-default.svg": 7354,
	"./contacts/2-white.svg": 6066,
	"./contacts/3-default.svg": 6007,
	"./contacts/3-white.svg": 807,
	"./contacts/4-default.svg": 2280,
	"./contacts/4-white.svg": 8200,
	"./history-bg.webp": 3089,
	"./history.webp": 9875,
	"./history/2014.webp": 7115,
	"./history/2018.webp": 4799,
	"./history/2020.webp": 7164,
	"./history/2024-1.webp": 1470,
	"./history/2024.webp": 5824,
	"./history/2025.webp": 5219,
	"./history/bg-2025.webp": 3073,
	"./icons/about/1.svg": 1062,
	"./icons/about/2.svg": 197,
	"./icons/arrow-dark.svg": 9839,
	"./icons/arrow-orange.svg": 5545,
	"./icons/arrow-purple.svg": 7757,
	"./icons/arrow-single-purple.svg": 3690,
	"./icons/arrow-single.svg": 2483,
	"./icons/arrow-white.svg": 8210,
	"./icons/arrow.svg": 7190,
	"./icons/career/1.svg": 6025,
	"./icons/career/2.svg": 7290,
	"./icons/cross-grey.svg": 3283,
	"./icons/cross-white.svg": 9513,
	"./icons/cross.svg": 9973,
	"./icons/download.svg": 1303,
	"./icons/line-violet.svg": 3791,
	"./icons/line.svg": 8361,
	"./icons/menu.svg": 2434,
	"./icons/search-active.svg": 3734,
	"./icons/search.svg": 4343,
	"./icons/sort/asc.svg": 2337,
	"./icons/sort/default.svg": 4089,
	"./icons/sort/desc.svg": 8869,
	"./logo/logo-big.svg": 1518,
	"./logo/logo-dark-mini.svg": 7632,
	"./logo/logo-icon-dark.svg": 3460,
	"./logo/logo-icon.svg": 1311,
	"./logo/logo-white.svg": 7195,
	"./logo/logo.svg": 9419,
	"./main-bg.webp": 1740,
	"./material-1.webp": 5618,
	"./material-2.webp": 515,
	"./materials/video_1.mp4": 7100,
	"./materials/video_2.mp4": 147,
	"./materials/video_3.mp4": 3758,
	"./media/1-dark.svg": 3927,
	"./media/1.svg": 2542,
	"./media/2-dark.svg": 5238,
	"./media/2.svg": 5517,
	"./media/3-dark.svg": 6945,
	"./media/3.svg": 8156,
	"./service-new.svg": 9798,
	"./service-white.svg": 8211,
	"./service.svg": 3411,
	"./start.mp4": 858,
	"./start.webp": 5267,
	"./styles/animation/animation.css": 423,
	"./styles/animation/animationScroll.css": 1380,
	"./styles/main.scss": 7649,
	"./styles/scrollBar.css": 7216,
	"./team.webp": 768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;